import Link from 'next/link';

export default function BandeauTop({ site }: { site: any }) {
  if (!site) return <></>;

  return (
    <div id="bandeau-top">
      <div className="inner">
        <div className="content">
          <svg className="bg-el-l" width="322" height="40" viewBox="0 0 322 40" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M239.446 7.31488L321.32 -134.496L195.779 -229.376C164.182 -253.257 119.671 -249.081 96.8655 -220.095L-18.6041 -73.3378C-20.2362 -71.2621 -21.6713 -69.0962 -23 -66.8859L143.52 29.2547C177.864 49.0832 221.031 39.2108 239.446 7.31488"
              fill="#0E2053"
            />
          </svg>
          <svg className="bg-el-r" width="126" height="42" viewBox="0 0 126 42" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.0421 131.922L115.222 131.922L124.838 54.5037C127.259 35.018 114.433 16.9427 96.3354 14.3365L4.70423 1.13893C3.40844 0.952724 2.12282 0.87344 0.844482 0.850891L0.844478 96.1758C0.844477 115.836 15.7832 131.922 34.0421 131.922"
              fill="#0E2053"
            />
          </svg>
          <div className="title">
            {site.content_top_banner.title}{' '}
            <Link href={site.content_top_banner.cta_link}>{site.content_top_banner.cta}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
